import { Component } from '@angular/core';
import { ToastController,NavController,NavParams,AlertController } from 'ionic-angular';
import { DTOInformacaoUsuario } from '../../dto/dtoInfomacaoUsuario';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { UsuarioDAO } from '../../daos/usuario-dao';
import { MenuComponent } from '../../components/menu/menu';
import { Usuario } from '../../entities/usuario';



@Component({
    selector: 'page-informacao-pessoal',
    templateUrl: 'informacao-pessoal.html'
})
export class InformacoesPessoaisPage {
    public formCadUsuario: FormGroup;
    public formAlterarSenha: FormGroup;
    public infoUsuario: DTOInformacaoUsuario;
    public usuario: Usuario = new Usuario();
    public senhaAtual: string;
    public novaSenha: string;
    public confirnmarSenha: string;
    isChecked={};
 


    constructor(public navCtrl: NavController,private _alertCtrl: AlertController
      ,private _formBuilder: FormBuilder,private _toastCtrl: ToastController,private _usuarioDao: UsuarioDAO,_navParams: NavParams) {
        this.infoUsuario = _navParams.get('usuario');  
          
     
        this.formCadUsuario = this._formBuilder.group({
          Email: ['', Validators.compose([Validators.required, Validators.minLength(1)])],
          Fone: ['', Validators.compose([Validators.required, Validators.minLength(1)])],
          DtAniversario: ['', ''],
          IdentificacaoLoja: ['', Validators.compose([Validators.required, Validators.minLength(1)])],
          Informativo: ['', '']
        }); 
        this.formAlterarSenha = this._formBuilder.group({
          SenhaAtual: ['', Validators.compose([Validators.required, Validators.minLength(1)])],
          NovaSenha: ['', Validators.compose([Validators.required, Validators.minLength(1)])],
          ConfirmarSenha: ['', Validators.compose([Validators.required, Validators.minLength(1)])]
        }); 
        
 
    }


    alterarSenha() {
      if (this.formAlterarSenha.invalid) {
        this._toastCtrl.create({
            message: 'Todos os campos devem ser preenchidos. Favor Verifique!',
            duration: 3000
        }).present();

        return;
      }  

      if (this.senhaAtual != this.infoUsuario.Senha){
        this._toastCtrl.create({
            message: 'Senha atual não confere!',
            duration: 3000
        }).present();
        return;
      }

      if (this.novaSenha != this.confirnmarSenha){
        this._toastCtrl.create({
            message: 'Nova Senha deve ser confirmada!',
            duration: 3000
        }).present();
        return;
      }

      this.usuario.Id = this.infoUsuario.IdUsuario;
      this.usuario.NomeUsuario = this.infoUsuario.NomeUsuario;
      this.usuario.CpfUsuario =  this.infoUsuario.CpfUsuario;
      this.usuario.Empresa = this.infoUsuario.Empresa;
      this.usuario.Perfil = this.infoUsuario.Perfil;
      this.usuario.Email = this.infoUsuario.Email;
      this.usuario.Ativo = '1';
      this.usuario.NomeEmpresaUsuario = this.infoUsuario.NomeEmpresaUsuario;
      this.usuario.CnpjEmpresaUsuario = this.infoUsuario.CnpjEmpresaUsuario;
      this.usuario.IdentificacaoLoja = this.infoUsuario.IdentificacaoLoja;
      this.usuario.Fone = this.infoUsuario.Fone;      
      this.usuario.Senha = this.novaSenha;
      this.usuario.DtAniversario = this.infoUsuario.DtAniversario;
      this.usuario.Informativo = this.infoUsuario.Informativo;

      

      this._usuarioDao.alterarUsuario(this.usuario)
      .then(r => {
        this.navCtrl.setRoot(MenuComponent, { usuario: this.infoUsuario })
        this.alertaDeAviso('Senha alterado com sucesso!');
      }, e => {
        console.error('Não foi possível salvar o usuário.');
        this.alertaErro(`Houve um erro inesperado. ${e.mensagem}`);
      });   



    }


    alterarUsuario() {
      if (this.formCadUsuario.invalid) {
        this._toastCtrl.create({
            message: 'O formulário está invalido. Favor Verifique!',
            duration: 3000
        }).present();

        return;
      }

      this.usuario.Id = this.infoUsuario.IdUsuario;
      this.usuario.NomeUsuario = this.infoUsuario.NomeUsuario;
      this.usuario.CpfUsuario =  this.infoUsuario.CpfUsuario;
      this.usuario.Empresa = this.infoUsuario.Empresa;
      this.usuario.Perfil = this.infoUsuario.Perfil;
      this.usuario.Email = this.infoUsuario.Email;
      this.usuario.Ativo = '1';
      this.usuario.NomeEmpresaUsuario = this.infoUsuario.NomeEmpresaUsuario;
      this.usuario.CnpjEmpresaUsuario = this.infoUsuario.CnpjEmpresaUsuario;
      this.usuario.IdentificacaoLoja = this.infoUsuario.IdentificacaoLoja;
      this.usuario.Fone = this.infoUsuario.Fone;      
      this.usuario.Senha = this.infoUsuario.Senha;
      this.usuario.DtAniversario = this.infoUsuario.DtAniversario;
      this.usuario.Informativo = this.infoUsuario.Informativo;
      //console.log("Usuaário:"+this.usuario.Informativo);
      this.salvarUsuario();

    }

    salvarUsuario() {

      this._alertCtrl.create({
        title: 'Informe a senha para atualizar as informações.',
        subTitle: `Após a confirmação, as informações serão atualizadas.`,
        inputs: [
            {
                name: 'Senha',
                type:"password",
                placeholder: 'Informe a senha...' 
            },
        ],
        buttons: [
            {
                text: 'Confirmar',
                handler: (data) => {
                    if (data.Senha != this.infoUsuario.Senha) {
                        this.alertaDeAviso('Senha é incorreta!');
                        return;
                    }
                  
                    this._usuarioDao.alterarUsuario(this.usuario)
                    .then(r => {
                      this.navCtrl.setRoot(MenuComponent, { usuario: this.infoUsuario })
                    }, e => {
                      console.error('Não foi possível salvar o usuário.');
                      this.alertaErro(`Houve um erro inesperado. ${e.mensagem}`);
                    });                                                
                    
                    
                }
            }
        ]
    }).present();

      
    }


    alertaErro(msg: string) {
      this._alertCtrl.create({
          message: msg,
          title: 'Ops... 😔',
          buttons: [{
              text: 'Ok, estou ciente'
          }]
      }).present();
    }

    alertaDeAviso(msg: string) {
      this._alertCtrl.create({
          message: msg,
          title: 'Atenção ⚠️',
          buttons: [{
              text: 'Ok'
          }]
      }).present();
  }



}


// WEBPACK FOOTER //
// ./src/pages/informacao-pessoal/informacao-pessoal.ts